import { useEffect } from 'react';
import Sdk from 'casdoor-js-sdk';
import { AuthCallback } from 'casdoor-react-sdk';
import { useNavigate } from 'react-router-dom';
import { setCookie, getCookie } from '@/app/common/utils/cookieService';
import { getBaseApiPath } from '@/app/common/api/config';
import { takeAuthReturnTo } from './authReturnTo';

const sdkConfig = {
  serverUrl: import.meta.env.VITE_ACCOUNT_SERVER_URL || 'http://localhost:3001',
  appName: import.meta.env.VITE_CASDOOR_APPNAME,
  clientId: import.meta.env.VITE_CASDOOR_CLIENTID,
  organizationName: import.meta.env.VITE_CASDOOR_ORG,
  redirectPath: import.meta.env.VITE_CASDOOR_REDIRECT,
  signinPath: import.meta.env.VITE_CASDOOR_SIGNINPATH
};

export const CasdoorSdk = new Sdk(sdkConfig);

type TokenResponse = {
  success?: boolean;
  data: {
    access_token: string;
    refresh_token: string;
  };
};

const CasdoorCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      const access = getCookie(import.meta.env.VITE_ACCESS_TOKEN_NAME);
      const refresh = getCookie(import.meta.env.VITE_REFRESH_TOKEN_NAME);
      if (!access || !refresh) return;
      navigate(takeAuthReturnTo() || '/');
    }, 8000);
    return () => window.clearTimeout(timer);
  }, [navigate]);

  return (
    <AuthCallback
      sdk={CasdoorSdk}
      serverUrl={getBaseApiPath()}
      saveTokenFromResponse={res => {
        const tokenRes = res as unknown as TokenResponse;
        setCookie(
          import.meta.env.VITE_ACCESS_TOKEN_NAME,
          tokenRes.data.access_token
        );
        setCookie(
          import.meta.env.VITE_REFRESH_TOKEN_NAME,
          tokenRes.data.refresh_token
        );
        navigate(takeAuthReturnTo() || '/');
      }}
      isGetTokenSuccessful={res =>
        (res as unknown as TokenResponse).success === true
      }
    />
  );
};

export default CasdoorCallback;
